'use client';

import React, { useEffect, useState, useRef } from 'react';
import { cn } from '@/utils/cn';
import CheckOrderStatusGuest from '../Order/CheckOrderStatusGuest';

function CheckOrderStatus({ onView, onClose }) {
  const inputRef = useRef(null);
  const modalRef = useRef(null);
  const [openModal, setOpenModal] = useState(onView);

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }, 5);
      }, 10);
    } else {
      setOpenModal(false);
    }
  }, [onView]);

  const handleClose = () => {
    setOpenModal(false);
    setTimeout(() => {
      onClose(false);
    }, 2);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
      }
    };

    if (openModal) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [openModal]);

  return (
    <div
      ref={modalRef}
      className={cn(
        'check-order-status invisible w-full min-w-[400px] bg-white p-24 absolute top-9 right-0 z-[550] rounded-xl shadow-terms-conditions ',
        {
          'visible ': openModal,
        },
      )}
    >
      <CheckOrderStatusGuest onSubmitHandler={handleClose} />
    </div>
  );
}

export default CheckOrderStatus;
